module.exports = __webpack_public_path__ + "static/media/ur-PK.27432783.md";